import { useAuthApolloClient } from '@sit/client-shared';
import { useAppSelector } from '@web/redux/store';
import { config } from '../config/env';
import { selectToken } from '../redux/selectors';

export function useAppApolloClient(skip?: boolean) {
  const token = useAppSelector(selectToken);
  return useAuthApolloClient(token, config.graphqlUrl, config.subscriptionsUrl, skip);
}
